import React from 'react';
import V2Layout from '../Layout';
import { Box, Button, Checkbox, FormControlLabel, Grid, LinearProgress, MenuItem, Paper, Stack, TextField } from '@mui/material';
import { translate } from '../../../i18n/customI18nProvider';
import Swal from 'sweetalert2';
import { convertMessageCodeToMessage } from '../../../util';
import { getRight } from '../../../services/storage';
import { getCategoryDetails, createCategory, saveCategoryDetails } from '../../../services/wristbandCategory.service';

class AddEditWristbandCategory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            current_right: getRight(),
            loading: false,
            form_error: {},
            category_id: null,
            name: '',
            custom: false,
            type: 'paper',
        }
    }

    async setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }

    async componentDidMount() {
        let mode = this.props?.match?.params?.category_id ? 'edit' : 'add';
        let category_id = this.props?.match?.params?.category_id ? this.props.match.params.category_id : null;
        await this.setState({
            loading: true,
            mode,
            category_id,
            title: mode === 'add' ? translate('custom.add_wristband_category') : translate('custom.edit_wristband_category')
        });

        if (mode === 'edit')
            await this.getCategory();
            
        
        this.setState({ loading: false });
    }   

    async getCategory() {
        // if category_id, fetch category details
        let category = await getCategoryDetails(this.state.category_id);
        if (category.error) {
            Swal.fire({
                icon: 'error',
                title: translate('custom.error'),
                text: category.error_code ? convertMessageCodeToMessage(category.error_code) : category.error
            });
            return;
        }

        await this.setStateAsync({
            name: category.name ? category.name : '',
            custom: category.custom ? category.custom : false,
            type: category.type ? category.type : 'paper',
        });
    }

    async save(save_and_add=false) {

        if (!this.isFormValid()) return;

        let payload = {
            name: this.state.name,
            custom: this.state.custom,
            type: this.state.type,
        }

        let response;

        if (this.state.mode === 'add') {
                response = await createCategory(payload);
        } else if (this.state.mode === 'edit') {
                response = await saveCategoryDetails(this.state.category_id, payload);
        }


        if (response.error) {
            Swal.fire({
                icon: 'error',
                title: translate('custom.error'),
                text: response.error_code ? convertMessageCodeToMessage(response.error_code) : response.error
            });
            return;
        }

        if (save_and_add) {
            this.resetForm();
        } else {
            this.props.history.push(`/v2/admin/wristbands`);
        }

        Swal.fire({
            icon: 'success',
            title: translate('custom.success'),
            text: translate('custom.saved_successfully'),
            showConfirmButton: false,
            timer: 1500
        });


    }

    resetForm() {
        this.setState({
            name: '',
            custom: false,
            type: 'paper',
        });
    }

    isFormValid(key=null) {

        let form_error = this.state.form_error;

        if (!key || key == 'name') {
            if (this.state.name === '' || !this.state.name) {
                form_error['name'] = translate('custom.required');
            } else {
                delete form_error['name'];
            }
        }
        
        if (Object.keys(form_error).length > 0) {
            this.setState({ form_error });
            return false;
        } else {
            this.setState({ form_error: {} });
            return true;
        }

    }

    render() {
        return (
            <V2Layout
                currentMenu='wristbands'
                title={this.state.title}
            >

                {(this.state.loading) ? (
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                ) : null}

                <Paper sx={{mt: 2, padding: 2}}>
                    <Grid container spacing={2}>

                        <Grid item xs={12} md={4} lg={4} xl={4}>
                            <TextField fullWidth label={translate('custom.name')} variant='outlined'
                                value={this.state.name}
                                onChange={(e) => {
                                    this.setState({ name: e.target.value })
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} lg={4} xl={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.custom}
                                        onChange={(e) => this.setState({ custom: e.target.checked })}
                                        color="primary"
                                    />
                                }
                                label={translate('custom.custom')}s
                            />
                        </Grid>

                        <Grid item xs={12} md={4} lg={4} xl={4}>
                            <TextField
                                select
                                label={translate('custom.type')}
                                value={this.state.type}
                                onChange={(e) => this.setState({ type: e.target.value })}
                                fullWidth
                            >
                                <MenuItem key={1} value={"paper"}>
                                    {translate('custom.paper')}
                                </MenuItem>
                                <MenuItem key={2} value={"fabric"}>
                                    {translate('custom.fabric')}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} sx={{mt: 2, justifyContent: 'space-around'}}>
                        <Grid item xs={12}>
                            <Stack direction='row' spacing={2}>
                                <Button variant='contained' color='primary'
                                    onClick={async () => {
                                        await this.save();
                                    }}
                                    disabled={this.state.loading}
                                >
                                    {translate('custom.save')}
                                </Button>
                                {
                                    this.state.mode == 'edit' ? null : 

                                    <Button variant='outlined' color='primary'
                                        onClick={async () => {
                                            await this.save(true);
                                        }}
                                        disabled={this.state.loading}
                                    >
                                        {translate('custom.save_and_add')}
                                    </Button>
                                }
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            </V2Layout>
        );
    }
}

export default AddEditWristbandCategory;
